import { render, staticRenderFns } from "./change-modalteach.vue?vue&type=template&id=23fad900&"
import script from "./change-modalteach.vue?vue&type=script&lang=js&"
export * from "./change-modalteach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fad900')) {
      api.createRecord('23fad900', component.options)
    } else {
      api.reload('23fad900', component.options)
    }
    module.hot.accept("./change-modalteach.vue?vue&type=template&id=23fad900&", function () {
      api.rerender('23fad900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/change/components/change-modalteach.vue"
export default component.exports